import React from "react";
import banner from '../../../assets/images/whiky_house/1 louis-xiii-classic-70cl--lifestyle_2749x2048.png.webp'
const Banner = () => {
  return (
    <>
      <div className="min-h-[24.5rem] relative ">
        
        <img
          src={banner}
          className="absolute -z-10  w-full h-full object-cover "
          alt=""
        />
        <div className="z-10 min-h-[24.5rem] flex flex-col gap-4 items-center justify-center">
          <div>
            <h1 className="lg:text-4xl text-3xl text-white py-3 font-bold bg-[rgba(0,0,0,0.5)] font-['Open_Sans'] text-center px-8 ">
              {" "}
              Explore our whisky selection
            </h1>
          </div>
          <div className="text-center">
            <button
              class="self-start btn2 text-center border-[#DEC092] bg-[#DEC092] px-5 py-3 relative border e uppercase font-semibold tracking-wider leading-none overflow-hidden hover:text-black"
              type="button"
            >
              <span class="absolute inset-0 bg-white"></span>
              <span class="absolute inset-0 flex justify-center items-center font-bold ">
                Go To Shop
              </span>
              Go To Shop
            </button>
          </div>
        </div>
      </div>
      {/* <div className="md:block hidden">
        <div className="flex  justify-between items-center bg-[#0E0F14]">
          <div className=" flex flex-col lg:pl-20 pl-10 gap-6 ">
            <h1 className="lg:text-4xl text-3xl font-bold text-white font-['Open_Sans']  ">
              Hereford Wine Festival 2023
            </h1>
            <p className="font-mono text-white text-[18px]">
              Join us on Saturday 8th of July and sample over 300 different
              wines
            </p>

            <button
              class="self-start btn2 border-[#DEC092] text-[#DEC092] px-5 py-3 relative border e uppercase font-semibold tracking-wider leading-none overflow-hidden hover:text-white"
              type="button"
            >
              <span class="absolute inset-0 bg-[#DEC092]"></span>
              <span class="absolute inset-0 flex justify-center items-center font-bold">
                Go To Shop
              </span>
              Go To Shop
            </button>
          </div>
          <img className=" w-[550px]  " src={banner} alt="" />
        </div>
      </div> */}
    </>
  );
};

export default Banner;
